import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import NewsletterSignup from "../components/NewsletterSignup/NewsletterSignup";

const Join = () => {
  const klaviyoListId = process.env.REACT_APP_KLAVIYO_LIST_ID;
  const [isSignedUp, setIsSignedUp] = useState<boolean>(false);
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isCommissioner, setIsCommissioner] = useState<boolean | null>(null);
  const navigate = useNavigate();

  /* const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setIsLoading(true);

    try {
      const trimmedEmail = email.toLowerCase().trim();

      // This is the correct path when deployed to Netlify
      const response = await fetch("/.netlify/functions/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: trimmedEmail,
          listId: klaviyoListId,
        }),
      });

      // Handle the response
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message ?? `Subscription failed with status: ${response.status}`
        );
      }

      setMessage("Successfully subscribed!");
      setEmail("");
      setIsSignedUp(true);
    } catch (error: any) {
      console.error("Newsletter subscription error:", error);
      setMessage(
        `Error: ${error.message || "Failed to subscribe. Please try again."}`
      );
      setIsSignedUp(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDemoSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setIsLoading(true);

    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        throw new Error("Please enter a valid email address");
      }

      setMessage("Successfully subscribed!");
      setEmail("");
      setIsSignedUp(true);
    } catch (error: any) {
      console.error("Newsletter subscription error:", error);
      setMessage(
        `Error: ${error.message || "Failed to subscribe. Please try again."}`
      );
      setIsSignedUp(false);
    } finally {
      setIsLoading(false);
    }
  }; */

  const handleCommissionerClick = () => {
    navigate("/signup"); // Navigate to sign-up page
  };

  // if (!mounted) return null;

  const renderNewsletterForm = () => ({
    /* <>
      <div className="drawerHeading">
        Sign up for the Fantasy Loser newsletter and receive draft order ideas,
        punishment content, and updates on new features.
      </div>
      <form
        onSubmit={
          process.env.NODE_ENV === "development"
            ? handleDemoSubmit
            : handleSubmit
        }
      >
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="example: HingleMcCringleberry@pennstate.edu"
          className="fldStyle"
          required
        />
        <button type="submit" disabled={isLoading} className="btnStyle">
          {isLoading ? "Submitting..." : "Submit"}
        </button>

        {message && (
          <div
            className={`formMsg ${
              message.startsWith("Error") ? "text-red-500" : "text-[#18f7b1]"
            }`}
          >
            {message}
          </div>
        )}
      </form>
    </> */
  });

  const renderCommissionerChoice = () => (
    <>
      <h3>IT'S GOOD!</h3>
      <p>
        <strong>
          Thanks for joining the Fantasy Loser community—big things are coming.
        </strong>
      </p>
      <p>Want early access to help shape the future of Fantasy Loser?</p>
      <div className="btnWrap">
        <button onClick={handleCommissionerClick} className="btnFilled">
          Waitlist for early access
        </button>
        <button className="btnStyle" onClick={() => navigate("/")}>
          No thanks
        </button>
      </div>
    </>
  );

  const renderContent = () => {
    if (!isSignedUp) {
      return <NewsletterSignup />;
    }

    if (isCommissioner === null) {
      return renderCommissionerChoice();
    }

    return null;
  };
  return (
    <div className="pageOuterWrapper">
      <Navbar />

      <div className="mainContentWrap">
        <div className="bannerWrap">
          <div className="wrapper">
            <h2>Stay in the loop</h2>
            <div className="bannerSubTxt">
              <p>
                Sign up for the{" "}
                <span className="highlightedTxt">Fantasy Loser newsletter</span>{" "}
                to get fresh challenges, punishment recaps, and insider updates
                as we grow.
              </p>
            </div>
          </div>
        </div>
        <div className="contentArea">
          <div className="wrapper">
            <div className="joinPageWrapper">{renderContent()}</div>
          </div>
        </div>
      </div>
      <Footer subscribeButton={false} />
    </div>
  );
};

export default Join;
